import { schema } from 'normalizr';

const categoriesSchema = new schema.Entity('categories');

export default {
  categoriesSchema,
};
